export default String.raw`
.bannerPromo {
    &__products {
        .card-product {
            &__image {
                    max-height: 135px;
            }
        }
    }

    &__placeholder {        
        &::after {
            content: 'Tablet';
        }
    }
}
`